module.exports = __webpack_public_path__ + "img/1440.a04f08c4.jpg";